import { NumberPrimitiveParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../constants';

export default (initialValue?: number): NumberPrimitiveParameterValue => ({
  type: PARAMETER_VALUE_TYPE.NUMBER_PRIMITIVE,
  value: initialValue || null,
});
